export default "__VITE_ASSET__CjadGvS3__"